import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import pluralize from 'rebook/apps/utils/text/pluralize';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';

import styles from './style.scss';


const VerticalAuthorCard = ({ author }) => {
  return (
    <a className={classNames(
      styles.tinyBook,
      'swiper-slide',
      'jest-VerticalAuthorCard',
    )}
    href={author.absolute_url}>
      <div className={styles.authorCover}>
        <CroppedImage className={styles.cover}
          height="112"
          width="112"
          src={author.photo} />
      </div>
      <div className={styles.bookInfo}>
        <div className={styles.authorName}>
          <MultilineEllipsisText maxLinesCount="2">
            {author.cover_name}
          </MultilineEllipsisText>
        </div>
        <div className={styles.authorCounter}>
          <span> {author.counters.books} {pluralize(author.counters.books, 'книга', 'книги', 'книг')}</span>
        </div>
      </div>
    </a>
  );
};

VerticalAuthorCard.propTypes = {
  author: PropTypes.object,
};

VerticalAuthorCard.defaultProps = {
  order: null,
  isActiveItem: false,
};

export default VerticalAuthorCard;
